import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Home as HomeIcon } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-stone-900 text-stone-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="bg-gradient-to-br from-cyan-500 to-teal-600 p-2 rounded-xl shadow-lg">
                <HomeIcon className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-xl font-bold text-white">
                LES FAÇADIERS <span className="text-cyan-500">HDF</span>
              </h3>
            </div>
            <p className="text-sm text-gray-400">
              {companyInfo.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-cyan-500 transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/a-propos" className="text-sm hover:text-cyan-500 transition-colors">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm hover:text-cyan-500 transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/realisations" className="text-sm hover:text-cyan-500 transition-colors">
                  Réalisations
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-cyan-500 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Nos services</h4>
            <ul className="space-y-2">
              <li className="text-sm">Ravalement de façade</li>
              <li className="text-sm">Isolation thermique</li>
              <li className="text-sm">Nettoyage et traitement</li>
              <li className="text-sm">Peinture et enduits</li>
              <li className="text-sm">Réparation</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <Phone className="w-4 h-4 mt-1 text-cyan-500" />
                <span className="text-sm">{companyInfo.phone}</span>
              </li>
              <li className="flex items-start space-x-2">
                <Mail className="w-4 h-4 mt-1 text-cyan-500" />
                <span className="text-sm">{companyInfo.email}</span>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 mt-1 text-cyan-500" />
                <span className="text-sm">{companyInfo.zone}</span>
              </li>
              <li className="flex items-start space-x-2">
                <Clock className="w-4 h-4 mt-1 text-cyan-500" />
                <span className="text-sm">{companyInfo.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-stone-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-stone-400">
              © {currentYear} Les Façadiers HDF. Tous droits réservés.
            </p>
            <div className="flex space-x-6">
              <Link to="/mentions-legales" className="text-sm text-gray-400 hover:text-cyan-500 transition-colors">
                Mentions légales
              </Link>
              <Link to="/politique-confidentialite" className="text-sm text-gray-400 hover:text-cyan-500 transition-colors">
                Politique de confidentialité
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;